import { useContext } from "react";
import { useParams } from "react-router-dom";

import { BoardContext } from "./BoardContext";
import { BOARD_TYPES } from "./const";

/**
 * Because Boards are now used both within Groups and Signups contexts,
 * the backend needs a way to distinguish between the two.
 * This hook determines which context the board is currently within
 * and plucks the necessary entity ID to be added to API requests.
 * @return (
 * { groupID } if in a Group context,
 * { signupListID } if in a Signup context,
 * {} otherwise
 * )
 *
 * @example
 * const groupOrSignupID = useGroupOrSignupID();
 * ...
 * API.reorderColumn(boardID, {
 *   columnID,
 *   newOrder: newOrderBy,
 *   ...groupOrSignupID,
 * })
 */
export default function useGroupOrSignupID() {
  const [{ groupID, boardType }] = useContext(BoardContext);
  const { signupListID } = useParams();

  if (boardType === BOARD_TYPES.SIGNUP) {
    const signupListIDAsNum = Number(signupListID);
    if (signupListIDAsNum > 0) {
      return {
        signupListID: signupListIDAsNum,
      };
    }
  }

  if (boardType === BOARD_TYPES.GROUP && groupID > 0) {
    return {
      groupID,
    };
  }

  return {};
}
